import {Timeline, TimelineLite} from "gsap";
import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {BalanceEvent} from "@nolimitcity/slot-game/bin/core/balance/event/BalanceEvent";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {HarlequinParsedGameData} from "../../server/data/HarlequinParsedGameData";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {HarlequinGameModuleConfig} from "../../HarlequinGameModuleConfig";
import {HarlequinSoundConfig} from "../../HarlequinSoundConfig";
import {HarlequinBackground} from "../../background/HarlequinBackground";
export class HarlequinZeroBet implements GameRoundPresentation {
    public stagger?:number = 0;

    private _inFreespin:boolean;
    private _inRespin:boolean;
    private _inRespinFS:boolean;
    private _intoRespin:boolean;
    private _intoRespinFS:boolean;
    private _isLastRespin:boolean
    private _inRespinRestore:boolean;
    private _freespinsLeft:number;

    // Restore specifics
    private _isRestore:boolean = false;
    private _scattersCollectedFSBefore:number = 0;
    private _scatterCollected:number;
    private _wildOverlays:boolean [] = [];
    private _wildMultipliers:number [] = [];

    // tmp
    private _data:any;
    private _signUpdated:boolean = false;

    constructor() {}

    public getAnimation(data:ParsedServerData):Timeline {
        const tl:TimelineLite = new TimelineLite();

        if(this._isRestore && (this._inFreespin || this._inRespinRestore)) {

            tl.add(this.handleFsRestore());
            if(this._inRespinRestore) {
                SlotGame.sound.playAmbience(HarlequinSoundConfig.instance.RESPIN_AMBIANCE);
            }
            //tl.add(HarlequinGameModuleConfig)
            if(this._inFreespin) {
                SlotGame.sound.fadeAmbience(0, 50);
                SlotGame.sound.playAmbience(HarlequinSoundConfig.instance.FREESPIN_AMBIANCE);
                SlotGame.sound.fadeAmbience(1, 50);
            }

        }
        // if RS noFS restore -> litNextHead

        tl.add([
           //(this._inFreespin)? () => {debugger;SlotGame.keypad.setZeroBetSpinCounter(--this._freespinsLeft);} : () => {},
            () => {
                    if((this._inRespinFS || this._intoRespinFS) && this._data.nextMode !== "FREESPIN") {
                        EventHandler.dispatchEvent(new GameEvent(BalanceEvent.ZERO_BET, this._freespinsLeft));
                    }
                    else {
                        // TODO: If respin send respins left
                        let numberLeft:number = -1;
                        this._wildOverlays.forEach((evalVal:boolean, index:number) => {
                            if(evalVal) {
                                numberLeft = index;
                            }
                        });
                        if(numberLeft > 1 && this._inRespin || this._intoRespin || this._data.nextMode === "WILD_RESPIN") {
                            let numberLeft:number = -1;
                            this._wildOverlays.forEach((evalVal:boolean, index:number) => {
                                if(evalVal) {
                                    numberLeft = index;
                                }
                            });

                            EventHandler.dispatchEvent(new GameEvent(BalanceEvent.ZERO_BET, --numberLeft));
                            // TODO: Update sign number
                            //HarlequinGameModuleConfig.harlequinSignView.setRespinSignAnimation(numberLeft)
                        }
                        else {
                            EventHandler.dispatchEvent(new GameEvent(BalanceEvent.ZERO_BET, (this._freespinsLeft <= 0) ? -1 : --this._freespinsLeft));
                        }

                        HarlequinGameModuleConfig.harlequinSignView.setRespinSignAnimation((this._isRestore && numberLeft <= 0)? -1 : --numberLeft);
                    }

                if(this._data.mode !== "FREESPIN" && this._data.mode !== "WILD_RESPIN_FS") {
                    //TODO: In FS do not send here

                        let numberLeft: number = -1;
                        this._wildOverlays.forEach((evalVal: boolean, index: number) => {
                            if (evalVal) {
                                numberLeft = index;
                            }
                        });

                        //TODO: In FS do not send here
                        HarlequinGameModuleConfig.harlequinSignView.setRespinSignAnimation(--numberLeft);
                }
            }
        ], (this._isRestore && this._inFreespin )? "+=0.5" : "+=0.7"); // TODO: Second delay is delaying entire respine flow, in now because of race condition when triggering respin intro repin numbers


        return tl;
    }

    protected handleFsRestore():Timeline {
        const tl:Timeline = new TimelineLite();


        if(this._isRestore && (this._data.mode === "FREESPIN" || this._data.nextMode === "FREESPIN")) {
            SlotGame.keypad.setZeroBetSpinCounter(this._freespinsLeft);
            (<HarlequinBackground> HarlequinGameModuleConfig.background).playBgSpine("bonusGame");
            //HarlequinGameModuleConfig.harlequinSignView.setRespinSignAnimation(this._freespinsLeft);
        }
        //tl.add(() => {
        //debugger;
            if(this._scattersCollectedFSBefore < 1) {
                if(this._data.mode === "FREESPIN" || this._data.mode === "WILD_RESPIN_FS") {
                    //HarlequinGameModuleConfig.harlequinSignView.playSignSpine("respinToBonusGameWon");
                    HarlequinGameModuleConfig.harlequinSignView.enterMode(this._data.mode, this._data.nextMode, undefined, this._isRestore);
                }

                if(this._isRestore && this._data.mode == "FREESPIN" || this._data.mode == "WILD_RESPIN" || this._data.mode == "WILD_RESPIN_FS" || this._data.nextMode === "WILD_RESPIN_FS") {
                    if(this._data.mode !== "WILD_RESPIN") {
                        HarlequinGameModuleConfig.harlequinSignView.playMiddleBar("New3HeadsDefault");
                    }

                    if(this._data.mode === "WILD_RESPIN_FS" || this._data.nextMode === "WILD_RESPIN_FS") {
                        this._signUpdated = true;
                        let numberLeft:number = -1;
                        this._wildOverlays.forEach((evalVal:boolean, index:number) => {
                            if(evalVal) {
                                numberLeft = index;
                            }
                        });

                        if(this._data.mode === "FREESPIN" && this._data.nextMode === "WILD_RESPIN_FS" && numberLeft > 0) {
                            this._signUpdated = true;
                            HarlequinGameModuleConfig.harlequinSignView.playSignSpine("baseGameToRespin", undefined, undefined, undefined, numberLeft - 1);
                        }

                        if(this._data.fromMode === "NORMAL" && this._data._toMode === "WILD_RESPIN") {
                            //this._signUpdated = true;

                            HarlequinGameModuleConfig.harlequinSignView.playMiddleBar("New3HeadsDefault");
                            HarlequinGameModuleConfig.harlequinSignView.playRightBar("New3HeadsBonusGameTextDefault");
                            HarlequinGameModuleConfig.harlequinSignView.playSignSpine("baseGameToRespin", undefined, undefined, undefined, numberLeft - 1);
                        }
                        else {
                            HarlequinGameModuleConfig.harlequinSignView.playLeftBar("NewBaseGameToRespin");
                            //HarlequinGameModuleConfig.harlequinSignView.enterMode(this._data.mode, this._data.nextMode, undefined, this._isRestore);
                        }
                        /*else {
                            HarlequinGameModuleConfig.harlequinSignView.playLeftBar("NewBaseGameToRespin");
                        }*/
                    }
                }
            }

            //if(this._data.mode === "FREESPIN" || this._data.mode === "WILD_RESPIN_FS") {

                /*let numberLeft: number = -1;
                this._wildOverlays.forEach((evalVal: boolean, index: number) => {
                    if (evalVal) {
                        numberLeft = index;
                    }
                });*/

                //HarlequinGameModuleConfig.harlequinSignView.setRespinSignAnimation(numberLeft);

            //}

            if(this._data.mode === "WILD_RESPIN" || this._data.nextMode === "WILD_RESPIN" || this._data.mode === "WILD_RESPIN_FS" || this._data.nextMode === "WILD_RESPIN_FS") {

                tl.add(() => {
                    let numberLeft:number = -1;
                    this._wildOverlays.forEach((evalVal:boolean, index:number) => {
                        if(evalVal) {
                            numberLeft = index;
                        }
                    });
                    // Plays sign animation
                    SlotGame.sound.playEffect(HarlequinSoundConfig.instance.RESPIN_INTRO);
                    SlotGame.sound.fadeAmbience(0, 50);
                    SlotGame.sound.playAmbience(HarlequinSoundConfig.instance.RESPIN_AMBIANCE);
                    SlotGame.sound.fadeAmbience(1, 50);
                    if(this._data.nextMode !== "FREESPIN") {
                        (<HarlequinBackground>HarlequinGameModuleConfig.background).playBgSpine("respin");
                    }

                    // TODO: Update number left handling
                    if(this._data.mode === "FREESPIN" && this._data.nextMode === "WILD_RESPIN_FS") { // TODO: probably wrong
                        //this._signUpdated = true;
                        HarlequinGameModuleConfig.harlequinSignView.playSignSpine("baseGameToRespin", undefined, undefined, undefined, numberLeft - 1);
                    }
                    else if(this._data.mode === "NORMAL" && this._data.nextMode === "WILD_RESPIN") {
                        HarlequinGameModuleConfig.harlequinSignView.playMiddleBar("New3HeadsDefault");
                        HarlequinGameModuleConfig.harlequinSignView.playRightBar("New3HeadsBonusGameTextDefault");
                        HarlequinGameModuleConfig.harlequinSignView.playSignSpine("baseGameToRespin", undefined, undefined, undefined, numberLeft - 1);
                    }
                    else if(this._data.mode === "WILD_RESPIN" && this._data.nextMode === "WILD_RESPIN") {
                        HarlequinGameModuleConfig.harlequinSignView.playRightBar("New3HeadsBonusGameTextDefault");
                        HarlequinGameModuleConfig.harlequinSignView.playLeftBar("NewRespinDefault", 0, false);
                        //HarlequinGameModuleConfig.harlequinSignView.playSignSpine("baseGameToRespin", undefined, undefined, undefined, numberLeft - 1);
                    }
                    else {
                        HarlequinGameModuleConfig.harlequinSignView.enterMode(this._data.mode, this._data.nextMode, undefined, this._isRestore);
                    }
                });

                tl.add(() => {
                    let numberLeft:number = -1;
                    this._wildOverlays.forEach((evalVal:boolean, index:number) => {
                        if(evalVal) {
                            numberLeft = index;
                        }
                    });

                    // Lit correct number of heads

                    if(this._scatterCollected && this._scatterCollected > 0) {
                        if(this._scatterCollected === 3) {
                            HarlequinGameModuleConfig.harlequinSignView.playHeadSpine(undefined, 0, true);
                            HarlequinGameModuleConfig.harlequinSignView.playHeadSpine(undefined, 1, true);
                            HarlequinGameModuleConfig.harlequinSignView.playHeadSpine(undefined, 2, true);
                        }
                        if(this._scatterCollected === 2) {
                            HarlequinGameModuleConfig.harlequinSignView.playHeadSpine(undefined, 0, true);
                            HarlequinGameModuleConfig.harlequinSignView.playHeadSpine(undefined, 1, true);
                        }
                        if(this._scatterCollected === 1) {
                            HarlequinGameModuleConfig.harlequinSignView.playHeadSpine(undefined, 0, true);
                        }
                    }

                    if(this._data.nextMode !== "FREESPIN" && this._data.nextMode !== "WILD_RESPIN_FS") {
                        HarlequinGameModuleConfig.harlequinSignView.setRespinSignAnimation(numberLeft);
                    }

                }, "+=0.5");
            }
        //});

        if(this._scattersCollectedFSBefore > 0) {
            tl.add(this.restoreCollectors());
        }

        return tl;
    }



    protected restoreCollectors():Timeline {
        const tl:TimelineLite = new TimelineLite();

        if(this._scattersCollectedFSBefore && this._scattersCollectedFSBefore > 0) {
            tl.add(() => HarlequinGameModuleConfig.harlequinScatterCollectorView.updateIndicator(this._scattersCollectedFSBefore - 1, true, false));
            tl.add(() => {}, "+=0.3")
        }

        return tl;
    }



    prepare(data:HarlequinParsedGameData):void {
        this._signUpdated = false;
        this._inFreespin = (data.mode === "FREESPIN" || data.mode === "WILD_RESPIN_FS");
        this._inRespin = (data.mode === "WILD_RESPIN");
        this._intoRespin = (data.mode === "NORMAL" && data.nextMode === "WILD_RESPIN");
        this._intoRespinFS = (data.mode === "FREESPIN" && data.nextMode === "WILD_RESPIN_FS");
        this._inRespinFS = (data.mode === "WILD_RESPIN_FS");
        this._inRespinRestore = (data.mode === "WILD_RESPIN" || data.nextMode === "WILD_RESPIN");
        this._isLastRespin = (data.nextMode === "NORMAL" || data.nextMode === "FREESPIN");

        this._freespinsLeft = data.freespinsLeft;
        this._isRestore = (<any>data).isRestoreState;
        this._data = data;
        //this._wildDrop = data.wildDrop || [false, false, false, false, false];
        this._wildOverlays = data.wildOverlayReels || [];
        this._wildMultipliers = data.wildMultipliers || [];
        this._scatterCollected = data.scatterCollected;


        if(data.scattersFSCollectedBefore > 0) {
        this._scattersCollectedFSBefore = data.scattersFSCollectedBefore;
        }

        if(this._isRestore && (this._inFreespin || this._inRespinRestore)) {

            if (this._wildMultipliers.length > 0) {
                HarlequinGameModuleConfig.harlequinWalkerView.restoreWilds(this._wildMultipliers, 0);
            }
        }

    }

}